import React, { ReactNode } from 'react';
import ErrorPage from '../404/404';
interface ErrorBoundaryProps {
	children: ReactNode;
}
class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
	state = {
		error: null,
	};
	static getDerivedStateFromError(error: Error | null) {
		return { error };
	}

	componentDidMount() {
		//window.onerror = this.logError;
	}
	componentDidCatch(error: Error | null, info: object) {
		this.logError(error);
	}

	render() {
		if (this.state.error) {
			return <ErrorPage errorType="technicalBreak" />;
		}
		return this.props.children;
	}

	logError(args: Error | null) {
		console.error(args);
		// Sentry.withScope((scope) => {
		// 	Sentry.captureException(args);
		// });
	}
}

export default ErrorBoundary;
